export default __webpack_public_path__ + "static/5-3b55cb11c35bb87b114acba58c0d1377.jpg";